export default __webpack_public_path__ + "static/media/first_data_diet.faaffbb0.svg";